import type { ExpectedSize } from '@/lib/api/provider';

export const EXPECTED_SIZE_OPTIONS: { label: string; value: ExpectedSize }[] = [
  { label: 'XXS (0 - 9 lbs)', value: 'XXS' },
  { label: 'XS (10 - 14 lbs)', value: 'XS' },
  { label: 'Small (15 - 34 lbs)', value: 'S' },
  { label: 'Medium (35 - 84 lbs)', value: 'M' },
  { label: 'Large (85 - 99 lbs)', value: 'L' },
  { label: 'XL (> 100 lbs)', value: 'XL' }
];

export const EXPECTED_SIZE_SELECT_OPTIONS = [
  { label: 'Select expected size...', value: '' },
  ...EXPECTED_SIZE_OPTIONS
];
